<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { mapState } from "vuex";

export default {
  locales: {
    pt: {},
    es: {},
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      token: window.localStorage.token
    }
  },
  mounted: function () {
    // data-sidebar vem do theme.helper (initThemeFromStorage / setTheme)
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) parent5.classList.add("mm-active");
          }
        }
      }
    }
  },
  methods: {},
};
</script>

<template>
  <div id="sidebar-menu" class="pt-3">
    <ul id="side-menu" class="metismenu list-unstyled">
      <li>
        <router-link tag="a" to="/" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
          <span class="notranslate">Painel</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/subscriptions" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M4 21h17v-2H5V3H3v17a1 1 0 0 0 1 1z"></path>
            <circle cx="10" cy="8" r="2"></circle>
            <circle cx="18" cy="12" r="2"></circle>
            <circle cx="11.5" cy="13.5" r="1.5"></circle>
            <circle cx="16.5" cy="6.5" r="1.5"></circle>
          </svg>
          <span class="notranslate">{{ t("Meu Plano") }}</span>
        </router-link>
      </li>
      <li>
        <a target="_blank" :href="'https://auditorias.mdoze.com.br/login/token/' + token" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M19.903 8.586a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.952.952 0 0 0-.051-.259c-.01-.032-.019-.063-.033-.093zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"></path><path d="M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"></path></svg>
          <span class="notranslate">Auditorias</span>
        </a>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="m17,13c-1.1,0-2-.9-2-2v-.36c0-.47.15-.91.43-1.23.91-1.07,1.26-2.49.96-3.88-.35-1.66-1.7-3.03-3.35-3.4-1.37-.31-2.77,0-3.85.86s-1.7,2.14-1.7,3.52c0,1.08.39,2.12,1.1,2.94.26.3.4.73.4,1.2v.36c0,1.1-.9,2-2,2-2.21,0-4,1.79-4,4v1c0,.55.45,1,1,1h16c.55,0,1-.45,1-1v-1c0-2.21-1.79-4-4-4Zm-12,4c0-1.1.9-2,2-2,2.21,0,4-1.79,4-4v-.36c0-.96-.32-1.85-.89-2.51-.39-.45-.61-1.03-.61-1.63,0-.76.34-1.48.94-1.96.61-.49,1.38-.65,2.16-.48.9.21,1.64.96,1.84,1.87.17.8-.02,1.57-.53,2.17-.59.69-.91,1.59-.91,2.53v.36c0,2.21,1.79,4,4,4,1.1,0,2,.9,2,2H5Z">
            </path>
            <path d="M3 20H21V22H3z"></path>
          </svg>
          <span class="notranslate">Jurídica</span>
        </a>
        <ul class="sub-menu">
          <li class="d-none">
            <router-link tag="a" to="/limpanome/dashboard" class="side-nav-link-ref">
              <span class="notranslate">Dashboard</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/limpanome" class="side-nav-link-ref">
              <span class="notranslate">Clientes</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/limpanome/processos" class="side-nav-link-ref">
              <span class="notranslate">Processos</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/limpanome/aprovados" class="side-nav-link-ref">
              <span class="notranslate">Aprovados</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M6 22h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h1zm6-17.001c1.647 0 3 1.351 3 3C15 9.647 13.647 11 12 11S9 9.647 9 7.999c0-1.649 1.353-3 3-3zM6 17.25c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18H6v-.75z"></path></svg>
          <span class="notranslate">Individual</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/exclusaoindividual" class="side-nav-link-ref">
              <span class="notranslate">Clientes</span>
            </router-link>
          </li>
          <li class="d-none">
            <router-link tag="a" to="/exclusaoindividual/aprovados" class="side-nav-link-ref">
              <span class="notranslate">Aprovados</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg width="24" height="24" viewBox="0 0 370 334" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g transform="matrix(1,0,0,1,-931.385956,-814.260693)">
              <g transform="matrix(4.166667,0,0,4.166667,0,0)">
                <g transform="matrix(1,0,0,1,230.19053,197.200424)">
                  <path d="M0,76.583L0,76.581C-6.366,72.92 -8.548,64.807 -4.873,58.463L26.19,4.857C29.867,-1.488 38.008,-3.661 44.376,0.001C50.744,3.664 52.925,11.777 49.249,18.121L18.186,71.728C14.511,78.07 6.368,80.244 0,76.583" style="fill: #888;fill-rule:nonzero;"/>
                </g>
              </g>
              <g transform="matrix(4.166667,0,0,4.166667,0,0)">
                <g transform="matrix(1,0,0,1,305.62953,197.202424)">
                  <path d="M0,76.579L0,76.581C-6.368,80.242 -14.509,78.068 -18.186,71.725L-49.249,18.119C-52.924,11.775 -50.743,3.662 -44.376,-0.001C-38.008,-3.663 -29.867,-1.49 -26.19,4.855L4.873,58.461C8.549,64.805 6.367,72.918 0,76.579" style="fill: #555;fill-rule:nonzero;"/>
                </g>
              </g>
              <g transform="matrix(4.166667,0,0,4.166667,0,0)">
                <g transform="matrix(1,0,0,1,278.89463,229.426424)">
                  <path d="M0,-28.225C-0.088,-28.353 -0.171,-28.484 -0.263,-28.609C-0.423,-28.825 -0.594,-29.029 -0.764,-29.232C-0.879,-29.37 -0.988,-29.511 -1.108,-29.643C-1.259,-29.809 -1.421,-29.964 -1.579,-30.121C-1.735,-30.278 -1.889,-30.436 -2.055,-30.586C-2.19,-30.708 -2.332,-30.817 -2.47,-30.932C-2.674,-31.1 -2.877,-31.271 -3.093,-31.429C-3.219,-31.522 -3.352,-31.604 -3.481,-31.692C-3.718,-31.853 -3.957,-32.013 -4.207,-32.161C-4.352,-32.245 -4.502,-32.322 -4.651,-32.402C-4.884,-32.529 -5.119,-32.651 -5.357,-32.763C-5.546,-32.85 -5.738,-32.929 -5.931,-33.007C-6.129,-33.09 -6.33,-33.17 -6.532,-33.242C-6.759,-33.322 -6.988,-33.392 -7.218,-33.461C-7.394,-33.512 -7.571,-33.562 -7.748,-33.607C-7.993,-33.669 -8.242,-33.721 -8.49,-33.768C-8.664,-33.801 -8.838,-33.833 -9.013,-33.859C-9.255,-33.895 -9.497,-33.922 -9.741,-33.945C-9.935,-33.963 -10.128,-33.979 -10.32,-33.988C-10.54,-34 -10.761,-34.003 -10.981,-34.003C-11.203,-34.003 -11.424,-34 -11.643,-33.988C-11.836,-33.979 -12.029,-33.963 -12.222,-33.945C-12.466,-33.922 -12.709,-33.895 -12.95,-33.859C-13.125,-33.833 -13.299,-33.801 -13.474,-33.768C-13.722,-33.721 -13.97,-33.669 -14.216,-33.607C-14.393,-33.562 -14.569,-33.512 -14.745,-33.461C-14.976,-33.392 -15.206,-33.322 -15.431,-33.242C-15.633,-33.17 -15.833,-33.09 -16.034,-33.007C-16.227,-32.929 -16.417,-32.85 -16.606,-32.763C-16.844,-32.651 -17.079,-32.529 -17.314,-32.402C-17.461,-32.322 -17.611,-32.245 -17.757,-32.161C-18.007,-32.013 -18.247,-31.852 -18.483,-31.692C-18.613,-31.604 -18.745,-31.522 -18.871,-31.429C-19.087,-31.271 -19.291,-31.1 -19.494,-30.931C-19.633,-30.817 -19.775,-30.707 -19.909,-30.586C-20.075,-30.436 -20.228,-30.278 -20.386,-30.121C-20.544,-29.963 -20.705,-29.809 -20.855,-29.643C-20.976,-29.511 -21.085,-29.37 -21.2,-29.232C-21.37,-29.029 -21.542,-28.825 -21.701,-28.609C-21.792,-28.484 -21.876,-28.353 -21.963,-28.225C-22.126,-27.988 -22.286,-27.749 -22.435,-27.499C-24.796,-23.513 -25,-18.412 -22.51,-14.118L-10.981,5.778L0.547,-14.118C3.035,-18.412 2.832,-23.513 0.472,-27.498C0.323,-27.749 0.162,-27.988 0,-28.225" style="fill: #333;fill-rule:nonzero;"/>
                </g>
              </g>
            </g>
          </svg>
          <span class="notranslate">Jusbrasil</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/jusbrasil" class="side-nav-link-ref">
              <span class="notranslate">Clientes</span>
            </router-link>
          </li>
          <li class="d-none">
            <router-link tag="a" to="/jusbrasil/aprovados" class="side-nav-link-ref">
              <span class="notranslate">Aprovados</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg width="24" height="24" viewBox="0 0 166 166" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
              <g transform="matrix(1,0,0,1,-68.439807,-65.441213)">
                  <g transform="matrix(1.333333,0,0,-1.333333,-200,500)">
                      <g id="path124-9" transform="matrix(1,0,0,1,0.75,-57.000001)">
                          <path d="M239.683,259.071L274.446,259.071L285.31,269.936L250.555,269.936L250.555,289.495L257.072,289.495L267.936,300.351L241.86,300.351L241.86,326.427L231.004,315.563L231.004,309.046L211.444,309.046L211.444,343.809L200.58,332.945L200.58,298.182L220.139,298.182L220.139,278.63L239.69,278.63L239.69,259.071" style="fill:currentColor;"/>
                      </g>
                  </g>
                  <g transform="matrix(1.333333,0,0,-1.333333,-200,500)">
                      <g id="path126-1" transform="matrix(1,0,0,1,0.75,-57.000001)">
                          <path d="M278.793,337.292L278.793,363.36L289.657,374.224L289.657,348.156L315.734,348.156L304.861,337.292L278.793,337.292" style="fill:currentColor;"/>
                      </g>
                  </g>
                  <g transform="matrix(1.333333,0,0,-1.333333,-200,500)">
                      <g id="path128-0" transform="matrix(1,0,0,1,0.75,-57.000001)">
                          <path d="M250.555,374.224L241.852,374.224L241.852,348.156L267.929,348.147L257.064,337.291L230.996,337.291L230.996,343.8L220.131,343.809L220.131,352.504L250.555,382.919L250.555,374.224" style="fill:currentColor;"/>
                      </g>
                  </g>
                  <g transform="matrix(1.333333,0,0,-1.333333,-200,500)">
                      <g id="path130-4" transform="matrix(1,0,0,1,0.75,-57.000001)">
                          <path d="M315.734,300.351L315.734,309.046L324.42,309.046L294.005,278.63L285.31,278.63L285.31,289.495L278.793,289.495L278.793,315.563L289.657,326.427L289.657,300.351L315.734,300.351" style="fill:currentColor;"/>
                      </g>
                  </g>
              </g>
          </svg>
          <span class="notranslate">Bacen</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/bacen" class="side-nav-link-ref">
              <span class="notranslate">Clientes</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M4 21h17v-2H5V3H3v17a1 1 0 0 0 1 1z"></path>
            <circle cx="10" cy="8" r="2"></circle>
            <circle cx="18" cy="12" r="2"></circle>
            <circle cx="11.5" cy="13.5" r="1.5"></circle>
            <circle cx="16.5" cy="6.5" r="1.5"></circle>
          </svg>
          <span class="notranslate">Pacotes</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/packages/buy" class="side-nav-link-ref">
              <span class="notranslate">Comprar</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/packages" class="side-nav-link-ref">
              <span class="notranslate">Meus Pacotes</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="d-none">
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path
              d="M19.023 16.977a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0 0 16 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z">
            </path>
          </svg>
          <span class="notranslate">Consultas</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/consultas/nova" class="side-nav-link-ref">
              <span class="notranslate">Nova Consulta</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/consultas" class="side-nav-link-ref">
              <span class="notranslate">Histórico</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/consultas/comprar" class="side-nav-link-ref">
              <span class="notranslate">Comprar</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/consultas/pedidos" class="side-nav-link-ref">
              <span class="notranslate">Meus Pedidos</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="d-none">
        <router-link tag="a" to="/polls" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path d="M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 16H4V5h16v14z"></path>
            <path d="M6 7h6v2H6zm0 4h12v2H6zm0 4h12v2H6z"></path>
          </svg>
          <span class="notranslate">Enquetes</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/informatives" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path
              d="M19.875 3H4.125C2.953 3 2 3.897 2 5v14c0 1.103.953 2 2.125 2h15.75C21.047 21 22 20.103 22 19V5c0-1.103-.953-2-2.125-2zm0 16H4.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008L3.988 5.046c.007-.01.052-.046.137-.046h15.75c.079.001.122.028.125.008l.012 13.946c-.007.01-.052.046-.137.046z">
            </path>
            <path d="M6 7h6v6H6zm7 8H6v2h12v-2h-4zm1-4h4v2h-4zm0-4h4v2h-4z"></path>
          </svg>
          <span class="notranslate">Informativos</span>
        </router-link>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 15V5h16l.001 10H4z"></path>
            <path d="m10 13 5-3-5-3z"></path>
          </svg>
          <span class="notranslate">Eventos</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/events" class="side-nav-link-ref">
              <span class="notranslate">Eventos</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/events/orders" class="side-nav-link-ref">
              <span class="notranslate">Minhas Compras</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/events/tickets" class="side-nav-link-ref">
              <span class="notranslate">Meus Ingressos</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path d="M12 10c1.151 0 2-.848 2-2s-.849-2-2-2c-1.15 0-2 .848-2 2s.85 2 2 2zm0 1c-2.209 0-4 1.612-4 3.6v.386h8V14.6c0-1.988-1.791-3.6-4-3.6z"></path>
            <path d="M19 2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h4l3 3 3-3h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-5 15-2 2-2-2H5V4h14l.002 13H14z"></path>
          </svg>
          <span class="notranslate">Rede</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/network/comissoes" class="side-nav-link-ref">
              <span class="notranslate">Comissões</span>
            </router-link>
          </li>
          <li class="d-none">
            <router-link tag="a" to="/network/team" class="side-nav-link-ref">
              <span class="notranslate">Equipe</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/network/matriz" class="side-nav-link-ref">
              <span class="notranslate">Matriz</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path d="M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"></path>
            <path d="m13.553 11.658-4-2-2.448 4.895 1.79.894 1.552-3.105 4 2 2.448-4.895-1.79-.894z"></path>
          </svg>
          <span class="notranslate">Relatórios</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/reports/indicacao" class="side-nav-link-ref">
              <span class="notranslate">Indicação</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/graduation" class="side-nav-link-ref">
              <span class="notranslate">Graduação</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link tag="a" to="/wallet/extract" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path d="M16 12h2v4h-2z"></path>
            <path
              d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z">
            </path>
          </svg>
          <span class="notranslate">Financeiro</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/courses" class="side-nav-link-ref">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path d="M2 7v1l11 4 9-4V7L11 4z"></path>
            <path d="M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"></path>
          </svg>
          <span class="notranslate">Universidade M12</span>
        </router-link>
      </li>
      <li>
        <a class="is-parent has-arrow" href="javascript:void(0);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1)">
            <path
              d="M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z">
            </path>
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
          </svg>
          <span class="notranslate">Suporte</span>
        </a>
        <ul class="sub-menu">
          <li>
            <router-link tag="a" to="/downloads" class="side-nav-link-ref">
              <span class="notranslate">Downloads</span>
            </router-link>
          </li>
          <li>
            <router-link tag="a" to="/faq" class="side-nav-link-ref">
              <span class="notranslate">FAQ</span>
            </router-link>
          </li>
          <li class="d-none">
            <router-link tag="a" to="/tickets" class="side-nav-link-ref">
              <span class="notranslate">Tickets</span>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.py-2 {
  padding: 0.9rem 1.5rem 0.7rem !important;
}

.py-2 i,
.py-2 span {
  line-height: 0px !important;
  padding-bottom: 0 !important;
}

.py-2 i {
  margin-top: -4px;
}
</style>
